import React from "react";
import { FaPencilAlt, FaKey, FaTrash } from "react-icons/fa";
import { useStore } from "../stores/store";
import { ModalKeys } from "../main";

const setAdminModalUser = useStore ? useStore.getState()?.setAdminModalUser : () => { };
const activateTool = useStore ? useStore.getState()?.activateTool : () => { };

export default [
    {
        id: "showDetails",
        header: () => <></>,
        size: 100,
        cell: ({ row }) => (
            <div className="flex justify-between">
                <button
                    onClick={() => {
                        setAdminModalUser(row.original);
                        activateTool(ModalKeys.EDIT_USER);
                    }}
                    className="btn btn-secondary btn-xs"
                >
                    <FaPencilAlt />
                </button>
                <button
                    onClick={() => {
                        setAdminModalUser(row.original);
                        activateTool(ModalKeys.RESET_USER_PASSWORD_CONFIRMATION);
                    }}
                    className="btn btn-info btn-xs"
                >
                    <FaKey />
                </button>
                <button
                    onClick={() => {
                        setAdminModalUser(row.original);
                        activateTool(ModalKeys.DELETE_USER_CONFIRMATION);
                    }}
                    className="btn btn-error btn-xs"
                >
                    <FaTrash />
                </button>
            </div>
        ),
    },
    {
        accessorKey: "UserName",
        size: 90,
        header: "User Name",
        cell: (info) => info.getValue(),
    },
    {
        accessorKey: "Email",
        size: 175,
        header: "Email",
        cell: (info) => info.getValue(),
    },
    {
        accessorKey: "FirstName",
        size: 90,
        header: "First Name",
        cell: (info) => info.getValue(),
    },
    {
        accessorKey: "LastName",
        size: 100,
        header: "Last Name",
        cell: (info) => info.getValue(),
    },
    {
        accessorKey: "Title",
        size: 120,
        header: "Title",
        cell: (info) => info.getValue(),
    },
    {
        accessorKey: "Agency",
        header: "Agency",
        cell: (info) => info.getValue(),
    },
    {
        accessorKey: "PhoneNumber",
        size: 100,
        header: "Phone Number",
        cell: (info) => info.getValue(),
    },
    {
        accessorKey: "AccountCreated",
        size: 90,
        header: "Account Created",
        cell: (info) => {
            const val = info.getValue();
            return val.split("T")[0];
        },
    },
    {
        accessorKey: "Active",
        size: 60,
        header: "Active",
        cell: (info) => {
            return info.getValue() ? "Yes" : "No";
        },
    },
    {
        accessorKey: "Roles",
        size: 110,
        header: "Role(s)",
        // cell: (info) => info.getValue(),
        cell: (info) => {
            return info.getValue().join(", ");
        },
    },
    {
        accessorKey: "LastLogin",
        size: 90,
        header: "Last Login",
        cell: (info) => {
            const val = info.getValue();
            return val.split("T")[0];
        },
    },
];